"use client";
import { useEffect, useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import RightViewModal from "@/components/modals/right-view-modal";
import { columns } from "../leads/table-components/columns";
import { NewLeadForm } from "../leads/components/NewLeadForm";
import { LeadDataTable } from "../leads/table-components/data-table";
import { useRouter } from "next/navigation";

const LeadsView = ({ data, crmData, userId }: any) => {
  const router = useRouter();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  const { users, accounts } = crmData;

  // Filter the leads based on the advisedBy value
  const filteredLeads = data.filter((lead: any) => lead.advisedBy === userId);

  return (
    <Card className="shadow-lg">
      <CardHeader className="pb-3">
        <div className="flex justify-between">
          <div>
            <CardTitle onClick={() => router.push("/crm/leads")} className="cursor-pointer">
              My Clients
            </CardTitle>
            <CardDescription></CardDescription>
          </div>
        
        </div>
      </CardHeader>
      <CardContent>
        {!filteredLeads || filteredLeads.length === 0 ? (
          "No assigned leads found"
        ) : (
          <LeadDataTable data={filteredLeads} columns={columns} />
        )}
      </CardContent>
    </Card>
  );
};

export default LeadsView;